export default __webpack_public_path__ + "static/media/award-badge.49c69095.png";